import { useState } from "react";
import { useDispatch } from "react-redux";

import { deleteStudentLevel } from "../../studentSlice";

import { Button } from "../../../../components/Button";

const DeleteStudentLevelButton = ({ student, levelId, name }) => {
  const dispatch = useDispatch();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleDeleteClick = (student, levelId, name) => {
    // levelId === 'unassigned'일 경우는 삭제 버튼이 안 보이므로, 여기서는 따로 처리가 필요 없을 수 있음
    setDeleteTarget({
      student,
      level: { id: levelId, name },
    });
    setIsDeleteModalOpen(true);
  };

  // [추가] 실제 삭제 로직
  const confirmDelete = () => {
    if (!deleteTarget) return;
    dispatch(
      deleteStudentLevel({
        studentId: deleteTarget.student.id,
        levelId: deleteTarget.level.id,
      })
    );
    setIsDeleteModalOpen(false);
    setDeleteTarget(null);
  };

  // [추가] 삭제 모달 닫기
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteTarget(null);
  };

  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div>
      <Button
        backgroundColor="#F6F8FA"
        color="#737373"
        border="1px solid #EBEBEB"
        fontSize="12px"
        padding="3px 8px"
        onClick={() => handleDeleteClick(student, levelId, name)}
      >
        삭제
      </Button>

      {isDeleteModalOpen && deleteTarget && (
        <div style={styles.modalOverlay} onClick={closeDeleteModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>학생 삭제</div>
            <div style={styles.modalBody}>
              <p style={{ textAlign: "center" }}>
                <strong>{deleteTarget.level.name}</strong>
                에서 <strong>{deleteTarget.student.name}</strong> 학생을
              </p>
              <p style={{ textAlign: "center" }}>삭제하시겠습니까?</p>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.dangerButton} onClick={confirmDelete}>
                네
              </button>
              <button style={styles.cancelButton} onClick={closeDeleteModal}>
                아니오
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteStudentLevelButton;
